import React from 'react';

import ProgressBar from '@atlaskit/progress-bar';

const ProgressBarIndeterminateExample = (): React.JSX.Element => {
	return <ProgressBar ariaLabel="Loading work items" isIndeterminate />;
};

export default ProgressBarIndeterminateExample;
